//import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import React, { useState } from 'react';
import Aside from './Aside';

function Layout(props, { setLocale }) {
    const [rtl, setRtl] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [image, setImage] = useState(false);
    const [toggled, setToggled] = useState(false);

    const handleCollapsedChange = (checked) => {
        setCollapsed(checked);
    };

    const handleRtlChange = (checked) => {
        setRtl(checked);
        setLocale(checked ? 'ar' : 'en');
    };
    const handleImageChange = (checked) => {
        setImage(checked);
    };

    const handleToggleSidebar = (value) => {
        setToggled(value);
    };

    return (

        <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>

            <Aside
                image={image}
                collapsed={collapsed}
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            />
            <div style={{ width: '100%', background: '#F5F5F6', overflow: 'scroll' }} >
                <NavMenu/>
                <div className="px-5 py-2">
                    {props.children}
                </div>
               
            </div>
        </div>
    );
}

export default Layout;